var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoofsays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.992,
    height: 17.422,
    viewBox: "0 0 19.992 17.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001",
    transform: "translate(-416.133 -461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(353 -89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_56",
    "data-name": "Union 56",
    transform: "translate(10693.53 18834.582)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10627.9-18270.889a5.511,5.511,0,0,1-2.5-4.264c-.064-3.662,4.358-6.723,9.878-6.842s10.048,2.744,10.112,6.4-4.354,6.727-9.874,6.846a14.251,14.251,0,0,1-4.3-.547l-5.176,2.135Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10627.6748046875 -18269.099609375 L -10624.9609375 -18270.21875 L -10624.63671875 -18270.353515625 L -10624.298828125 -18270.25390625 C -10623.1435546875 -18269.916015625 -10621.9033203125 -18269.744140625 -10620.6142578125 -18269.744140625 C -10620.5107421875 -18269.744140625 -10620.40625 -18269.74609375 -10620.302734375 -18269.748046875 C -10617.8271484375 -18269.80078125 -10615.5234375 -18270.482421875 -10613.818359375 -18271.6640625 C -10612.236328125 -18272.759765625 -10611.3798828125 -18274.1484375 -10611.4072265625 -18275.576171875 C -10611.4599609375 -18278.56640625 -10615.3916015625 -18280.998046875 -10620.1728515625 -18280.998046875 C -10620.2802734375 -18280.998046875 -10620.388671875 -18280.99609375 -10620.498046875 -18280.994140625 C -10622.9736328125 -18280.94140625 -10625.27734375 -18280.26171875 -10626.9833984375 -18279.080078125 C -10628.5654296875 -18277.984375 -10629.4228515625 -18276.595703125 -10629.3974609375 -18275.169921875 C -10629.3740234375 -18273.904296875 -10628.6328125 -18272.669921875 -10627.30859375 -18271.693359375 L -10626.6328125 -18271.1953125 L -10627.0068359375 -18270.443359375 L -10627.6748046875 -18269.099609375 M -10629.755859375 -18267.16015625 L -10627.90234375 -18270.888671875 C -10629.4296875 -18272.015625 -10630.3671875 -18273.50390625 -10630.3974609375 -18275.15234375 C -10630.4619140625 -18278.814453125 -10626.0390625 -18281.875 -10620.51953125 -18281.994140625 C -10620.4033203125 -18281.99609375 -10620.287109375 -18281.998046875 -10620.1728515625 -18281.998046875 C -10614.8115234375 -18281.998046875 -10610.470703125 -18279.173828125 -10610.4072265625 -18275.59375 C -10610.337890625 -18271.931640625 -10614.76171875 -18268.8671875 -10620.28125 -18268.748046875 C -10620.392578125 -18268.74609375 -10620.50390625 -18268.744140625 -10620.6142578125 -18268.744140625 C -10622.0263671875 -18268.744140625 -10623.3681640625 -18268.939453125 -10624.580078125 -18269.294921875 L -10629.755859375 -18267.16015625 Z",
    stroke: "none",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u2026",
    transform: "translate(421 471)",
    fill: "#373334",
    fontSize: 10,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2026")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoofsays);
export default __webpack_public_path__ + "static/media/noofsays.e709cd7d66c8ff0f8ae328943fdea2a2.svg";
export { ForwardRef as ReactComponent };